import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  inject,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Subscription } from "rxjs";
import {
  AirEmissionModalService,
  AirEmissionModalData,
  AirEmissionRow,
  SensorIssueItem,
} from "src/app/services/performance-service/air-emission-modal.service";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: "app-air-emission-modal",
  standalone: true,
  imports: [
    TranslateModule,CommonModule],
  templateUrl: "./air-emission-modal.component.html",
  styleUrls: ["./air-emission-modal.component.scss"],
})
export class AirEmissionModalComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();

  private modalService = inject(AirEmissionModalService);
  private dataSub: Subscription | null = null;

  // ── Data ────────────────────────────────────────────────────────────
  aiText              = "";
  tableRows: AirEmissionRow[]    = [];
  daysSinceExceedance = 0;
  sensorIssues: SensorIssueItem[] = [];
  recycledWastePct    = 0;

  // ── Lifecycle ────────────────────────────────────────────────────────
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isOpen"]) {
      const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
      if (ionContent) {
        if (this.isOpen) ionContent.style.setProperty("--overflow", "hidden");
        else             ionContent.style.removeProperty("--overflow");
      }
      if (this.isOpen) setTimeout(() => this.subscribeAndBuild(), 0);
      else {
        this.dataSub?.unsubscribe();
        this.dataSub = null;
      }
    }
  }

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
  }

  close(): void {
    this.closeModal.emit();
  }

  private subscribeAndBuild(): void {
    this.dataSub?.unsubscribe();
    this.dataSub = this.modalService.modalData$.subscribe((data: AirEmissionModalData | null) => {
      if (!data) {
        this.loadDummy();
        return;
      }
      this.aiText              = data.aiText;
      this.tableRows           = data.tableRows;
      this.daysSinceExceedance = data.daysSinceExceedance;
      this.sensorIssues        = data.sensorIssues;
      this.recycledWastePct    = data.recycledWastePct;
    });
  }

  private loadDummy(): void {
    this.aiText              = '';
    this.tableRows           = [];
    this.daysSinceExceedance = 0;
    this.sensorIssues        = [];
    this.recycledWastePct    = 0;
  }

  // ── Helpers ──────────────────────────────────────────────────────────
  get sensorMaxCount(): number {
    return Math.max(...this.sensorIssues.map(s => s.count), 1);
  }

  sensorBarWidth(count: number): number {
    return Math.round((count / this.sensorMaxCount) * 100);
  }

  get recycledWasteOffset(): number {
    const circumference = 276.46; // 2π × 44
    return circumference - (Math.min(this.recycledWastePct, 100) / 100) * circumference;
  }
}
